module.exports = __webpack_public_path__ + "img/arrow_up_square.5a7f5666.svg";